import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TableHeaderCell.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "th",
    {
      staticClass: "table-header-cell",
      attrs: {
        "sticky-header": _vm.stickyHeader,
        "sticky-left": _vm.stickyLeft,
        "sticky-right": _vm.stickyRight,
        sortable: _vm.column.sortable
      },
      on: { click: _vm.onClick }
    },
    [
      _vm._t(
        "default",
        [
          _c("span", { staticClass: "table-header-label" }, [
            _vm._v("\n            " + _vm._s(_vm.column.name) + "\n        ")
          ]),
          _vm._v(" "),
          _vm.column.sortable
            ? [
                _vm.sorted && _vm.sortedDesc
                  ? _c("ChevronDownIcon", { attrs: { size: "small" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sorted && !_vm.sortedDesc
                  ? _c("ChevronUpIcon", { attrs: { size: "small" } })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        {
          sortedDesc: _vm.sortedDesc,
          sorted: _vm.sorted,
          sortable: _vm.column.sortable
        }
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-06b87e2a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/TableHeaderCell.vue.js